import { ENGLISH_IQ_EVENTS } from '@repo/analytics';
import type { IAnswerEnglishIqV1Data } from '@repo/sdk';
import { trackEvent } from '@repo/web-chrome/lib/analytics';
import type { IEnglishIqStoredSession } from '../../state';

interface IApplyEnglishIqAnswerResponseParams {
  current: IEnglishIqStoredSession;
  data: IAnswerEnglishIqV1Data;
  finish: (token?: string) => Promise<void>;
  storeCompleting: (token: string) => void;
  storeSession: (session: IEnglishIqStoredSession) => void;
}

export async function applyEnglishIqAnswerResponse({
  current,
  data,
  finish,
  storeCompleting,
  storeSession,
}: IApplyEnglishIqAnswerResponseParams): Promise<void> {
  if (data.item || data.milestone) {
    storeSession({
      ...current,
      index: data.item ? current.index + 1 : current.index,
      item: data.item ?? current.item,
      milestone: data.milestone,
      token: data.token,
    });
  }
  if (data.milestone) {
    trackEvent(ENGLISH_IQ_EVENTS.milestone, {
      confidence: data.milestone.confidence,
      minuteMark: Math.round(data.milestone.markSeconds / 60),
    });
    return;
  }
  if (!data.item) {
    storeCompleting(data.token);
    await finish(data.token);
  }
}
